export function getCategories(state) {
  return Object.values(state.category.list);
}

export function getCategory(state, id) {
  return state.category.list[id] || {};
}

export function getCategorySuggestions(state) {
  return state.category.suggestionsList;
}
